import { render, staticRenderFns } from "./DeleteSelectedButton.vue?vue&type=template&id=3cd53b95&"
import script from "./DeleteSelectedButton.vue?vue&type=script&lang=js&"
export * from "./DeleteSelectedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports